export const BOOK_CALL_URL =
  "https://wa.me/918104796542?text=Hi%20Virelity!%20I'd%20like%20to%20book%20a%20free%20call%20about%20bringing%20AI%20into%20my%20business.";
export const CONTACT_EMAIL = "deon.menezes@virelity.com";
